import * as React from "react";
const SvgFiRrMagnetUser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-magnet-user_svg__a)">
      <path
        fill="#062147"
        d="M18 0c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.69-6-6-6m2.775 8.87A2.99 2.99 0 0 0 18.007 7h-.016a2.99 2.99 0 0 0-2.769 1.868A3.98 3.98 0 0 1 14 6c0-2.206 1.794-4 4-4s4 1.794 4 4a3.98 3.98 0 0 1-1.225 2.87M19.5 4.5a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001m-3.85 9.735c-.945-.945-2.593-.945-3.536 0l-1.439 1.439-1.732 1.733c-.672.673-1.746.75-2.389.168a1.65 1.65 0 0 1-.552-1.192 1.65 1.65 0 0 1 .486-1.219l1.838-1.838.001-.001 1.438-1.438a2.5 2.5 0 0 0 0-3.535l-.676-.677c-.944-.945-2.592-.945-3.536 0l-3.322 3.322c-2.97 2.97-2.97 7.803 0 10.772a7.6 7.6 0 0 0 5.386 2.228 7.6 7.6 0 0 0 5.386-2.228l1.882-1.882 1.438-1.439a2.5 2.5 0 0 0 0-3.535l-.677-.677zm-1.769 1.268c.077 0 .226.02.353.146l.677.677a.5.5 0 0 1 0 .707l-.732.732-1.383-1.383.733-.733a.5.5 0 0 1 .353-.146m-6.56-6.561c.076 0 .225.019.352.146l.677.677a.5.5 0 0 1 0 .707l-.732.732-1.383-1.383.733-.733a.5.5 0 0 1 .352-.146M3.643 20.355a5.624 5.624 0 0 1 0-7.944l1.176-1.176 1.383 1.383-1.132 1.132a3.68 3.68 0 0 0-1.07 2.685 3.64 3.64 0 0 0 1.211 2.627c1.448 1.303 3.705 1.197 5.142-.24l1.026-1.026 1.383 1.383-1.176 1.176a5.626 5.626 0 0 1-7.944 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-magnet-user_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMagnetUser;
